import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'

const Item = props => (
  <tr className={Styles.rowsContent}>
    <td>{props.data.name}</td>
    <td>{props.data.counter}</td>
    <td>
      <button
        className="material-icons pointer-type"
        onClick={props.removeSelectedData(props.index)}
      >
        delete
      </button>
    </td>
  </tr>
)

Item.defaultProps = {
  data: {
    name: '',
    counter: 0,
  },
  removeSelectedData: () => { },
  index: 0,
}

Item.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    counter: PropTypes.number,
  }),
  removeSelectedData: PropTypes.func,
  index: PropTypes.number,
}

export default Item
